export default function ModifiedFlag(props) {
  return (
    <span
      className="pwx-modified-flag dx-icon-rename"
      hidden={!props.isModifiedProperty}
    />
  );
}